// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __read } from "tslib";
/**
 * Returns a canonical query string.
 *
 * @param searchParams `searchParams` from the request url.
 * @returns URL-encoded query string parameters, separated by ampersands (&). Percent-encode reserved characters,
 * including the space character. Encode names and values separately. If there are empty parameters, append the equals
 * sign to the parameter name before encoding. After encoding, sort the parameters alphabetically by key name. If there
 * is no query string, use an empty string ("").
 *
 * @internal
 */
export var getCanonicalQueryString = function (searchParams) {
    return Array.from(searchParams)
        .sort(function (_a, _b) {
        var _c = __read(_a, 2), keyA = _c[0], valA = _c[1];
        var _d = __read(_b, 2), keyB = _d[0], valB = _d[1];
        if (keyA === keyB) {
            return valA < valB ? -1 : 1;
        }
        return keyA < keyB ? -1 : 1;
    })
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return escapeUri(key) + "=" + escapeUri(val);
    })
        .join('&');
};
var escapeUri = function (uri) {
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function (c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};
//# sourceMappingURL=getCanonicalQueryString.js.map